import {getText} from './get-text';

window.getJson = getJson;

/**
 * Fetches JSON from a URL and parse
 * NOTE: always use this method to download jsons. Some TVs could hang on `JSON.parse` execution
 * @param url - The URL to fetch JSON from
 */
export function getJson<T extends object>(url: string): Promise<T> {
  return getText(url).then((response) => {
    try {
      if (!response) {
        return Promise.reject(new Error(`Empty response received from server while fetching json file from "${url}"`));
      }

      // Parse JSON using Function constructor trick to avoid using JSON.parse.
      // NOTE: JSON.parse is extremely slow on some old TVs like LX
      const f = new Function(`return ${response};`);
      return f() as T;
    } catch (parseError) {
      // Handle parsing errors
      const errorMessage = parseError instanceof Error ? parseError.message : 'Unknown parsing error';
      return Promise.reject(new Error(`Failed to parse JSON response: ${errorMessage}`));
    }
  });
}

declare global {
  interface Window {
    getJson: typeof getJson
  }
}
